import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetActiveMenuToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Box, Grid } from "@mui/material";
// import { Check, Delete, Edit } from "@mui/icons-material";
import TableList from "./CustomTool/TableList";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtBtn from "./CustomTool/CtBtn";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { apiURL } from "./API";

class SetTaxPaidRate extends Component {
  state = {
    formData: {
      txtTPRate: "",
    },
  };

  //#region Component
  componentDidMount() {
    // document.title = "RiTe Account : Tax Paid Rate";
    this.props.setActiveMenu("SetTaxPaidRate");
    document.getElementById("txtTPRate").focus();
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        this.props.onTpTextChange(e.target.value);
      }
    );
  };
  //#endregion Handles

  //#region Function
  validateSelectionData = () => {
    let result = false;
    if (Number(this.state.formData.txtTPRate) <= 0) {
      this.props.toastErrorMsg("Enter Tax Paid Rate");
    } else {
      result = true;
    }
    return result;
  };

  onEnterPress = () => {
    if (this.props.closeTaxPaidRateARD) {
      this.props.closeTaxPaidRateARD();
    }
  };
  //#endregion

  render() {
    //document.getElementById("txtTPRate").focus();
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          marginTop={0}
          marginBottom={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtTPRate"
              label="Tax Paid Rate"
              value={this.state.formData.txtTPRate}
              handleOnChange={this.handleOnChange}
              width={110}
              maxLength={15}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.onEnterPress}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenuToProps
  )(HoCtToastContainer(SetTaxPaidRate))
);
